export const ContactView = () => {
  const title = "Contact Form";
  return (
    <div className="inline-flex flex-col gap-5 text-justify w-full">
      <div>
        <h3>{title}</h3>
        <hr className="border-t border-black" />
        <iframe
          title="form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSeINcRRStxIS1hvNtG_0CeBM69tSklSWVWPQPLz1h7HMCV9iw/viewform?embedded=true"
          width="100%"
          height="1250"
          frameBorder="0"
          marginHeight={0}
          marginWidth={0}
        >
          Loading…
        </iframe>
      </div>
    </div>
  );
};
